import React from 'react';
import {useState, useEffect} from 'react';
import BottomCard from './Certificate';
import {directDeepLink, SOURCE_HOME} from './Certificate/util';
import './index.css';
import baseURLGlobal from '../../utils/util';
import html2canvas from "html2canvas";
import certificateImg from "../../assets/images/birthday-sale-certificate3.png";

export default function EndCampaignPage() {
    const [showDrawer, setShowDrawer] = useState(false);
    const [data, setData] = useState({});
    const [image, setImage] = useState({});
    const baseUrl = baseURLGlobal;
    let url = new URL(window.location.href);
    let token = url.searchParams.get("token");


    useEffect(() => {
        getEndCampaignDetails();
    }, []);

    const getEndCampaignDetails = async () => {
        var myHeaders = new Headers();
        myHeaders.append("api-version", "25");
        myHeaders.append("x-access-token", token);
        var requestOptions = {
            method: "GET",
            headers: myHeaders,
            redirect: "follow",
        };
        await fetch(`${baseUrl}/v2/course/campaign/home`, requestOptions)
            .then((response) => response.json())
            .then((result) => {
                setData(result?.data);
            })
            .catch((error) => console.log("error", error));
    };

    const captureImage = () => {
        const slideElement = document.getElementById("certificateBoxElement");
        if (!slideElement) {
            console.error("captureImage: Element not found. Ensure the selector is correct.");
            return;
        }
        html2canvas(slideElement, { scrollY: -window.scrollY, allowTaint: true, useCORS: true })
            .then((canvas) => {
                canvas.toBlob((blob) => {
                    const downloadLink = document.createElement("a");
                    document.body.appendChild(downloadLink);
                    downloadLink.download = "poster.png";
                    downloadLink.href = canvas.toDataURL("image/png");
                    setImage(downloadLink.href);
                    document.body.removeChild(downloadLink);
                });
            })
            .catch((error) => {
                console.error("captureImage: Error during canvas generation or Blob creation.", error);
            });
    };

    const handleClick = () => {
        setShowDrawer(true);
        setTimeout(() => {
            captureImage();
        }, 0);
    }
    useEffect(() => {
    }, [showDrawer, setShowDrawer]);


    return (
        <>
            <div className="homeDisplay">
                <div className="slideCard slideCardEndSlide">
                    <div className="cardHeader">
                        <img
                            src="https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/birthday-sale-slide-home-header-title.png"
                            alt="title"/>
                    </div>
                    <div className="cardBody">
                        <img className="card-top-img"
                             src="https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/birthday-sale-end-card-top-img.png"
                             alt="img"/>
                        <hr/>
                        <div className="card-revenue-flex">
                            <h4>Your Revenue</h4>
                            <h2>{data?.totalRevenue}</h2>
                        </div>
                        <div className="end-camp-card-group">
                            <div className="end-camp-card"
                                 onClick={() => {
                                     directDeepLink(data?.formDeeplink, SOURCE_HOME)
                                 }}>
                                <img
                                    src="https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/birthday-sale-trophy-img-min.png"
                                    alt="trophy" width={50}/>
                                <p>Fill the google form to claim your rewards before they expire.</p>
                                <img
                                    src="https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/card-forward-white-icon.png"
                                    alt="overview card forward" height={16}/>
                            </div>
                            <div className="end-camp-card"
                                 onClick={handleClick}>
                                <img
                                    src="https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/birthday-sale-gift--img-min.png"
                                    alt="prize" width={50}/>
                                <p>Claim your surprise birthday gift certificate now.</p>
                                <img
                                    src="https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/card-forward-white-icon.png"
                                    alt="overview card forward" height={16}/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <BottomCard show={showDrawer} image={image} data={data} imageBlob={'certificateBoxElement'} setDrawer={setShowDrawer}/>

            <div id="certificateBoxElement" className="certificate-box">
                <div className="content-data">
                    <h4>{data?.certificateData?.heading}</h4>
                    <hr/>
                    <p>{data?.certificateData?.subtext}</p>
                </div>
            </div>
        </>
    )
}
